module.exports = __webpack_public_path__ + "img/svg/icon-players.29abc4cf822cf952926a8d5ee5d4a5e4.svg";